import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetTransportAccessTypesInputDto, TransportAccessTypeCreateDto, TransportAccessTypeDto, TransportAccessTypeExcelDownloadDto, TransportAccessTypeUpdateDto } from '../dtos/transport-access-type/models';

@Injectable({
  providedIn: 'root',
})
export class TransportAccessTypeService {
  apiName = 'WoodSupply';
  

  create = (input: TransportAccessTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TransportAccessTypeDto>({
      method: 'POST',
      url: '/api/woodSupply/transportAccessTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/woodSupply/transportAccessTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/woodSupply/transportAccessTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TransportAccessTypeDto>({
      method: 'GET',
      url: `/api/woodSupply/transportAccessTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/woodSupply/transportAccessTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetTransportAccessTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TransportAccessTypeDto>>({
      method: 'GET',
      url: '/api/woodSupply/transportAccessTypes',
      params: { name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: TransportAccessTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/woodSupply/transportAccessTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TransportAccessTypeDto[]>({
      method: 'GET',
      url: '/api/woodSupply/transportAccessTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: TransportAccessTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TransportAccessTypeDto>({
      method: 'PUT',
      url: `/api/woodSupply/transportAccessTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
